export default "__VITE_ASSET__BRHrEJYS__"